// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown_dropdown__I4Z9S","dropdown-box":"dropdown_dropdown-box__CFuVX","appearBox":"dropdown_appearBox__zVQI2","link":"dropdown_link__dDKHx"};